import { jsxs, jsx } from "react/jsx-runtime";
import { useMediaQuery, Snackbar, Alert, styled } from "@mui/material";
import { useState } from "react";
import brandclub_colors from "../../../colors/brandclubColors.js";
import { AppImage } from "../../../Components/AppImage/index.js";
import { getImageAssetUrl } from "../../../utils/assetUtils.js";
import { ButtonName } from "../../../theme/componentNames.js";
import { DIALOG_SCREEN_SIZE } from "../../../utils/constants/Constants.js";
import { Button } from "../../../Components/Button/Button.js";
const ShareDialogContentContainer = styled("div", {
  label: "ShareDialogContentContainer"
})(() => ({
  display: "flex",
  justifyContent: "center",
  gap: 16,
  ".platform": {
    marginTop: 10,
    width: "100%",
    maxWidth: 335,
    height: 50,
    justifyContent: "center",
    // gap: 8,
    alignItems: "center",
    border: `none !important`,
    transition: `background-color 0.3s ease-in-out`
  },
  "span.platform-title": {
    [`@media (max-width: ${DIALOG_SCREEN_SIZE}px)`]: {
      fontSize: 14
    }
  },
  ".link-copied-snackbar": {
    ".MuiPaper-root": {
      fontSize: 16,
      backgroundColor: brandclub_colors.white,
      borderRadius: 12,
      boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.16)",
      paddingTop: 0,
      paddingBottom: 0
    }
  }
}));
const SharePage = ({ url, onShareLinkCopied }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copyText, setCopyText] = useState("Copy Link");
  const desktopView = useMediaQuery(`(min-width:${DIALOG_SCREEN_SIZE}px)`);
  const handleCopyLink = async () => {
    navigator.clipboard.writeText(url);
    setCopyText("Link copied!");
    if (onShareLinkCopied) {
      await onShareLinkCopied();
    }
  };
  return /* @__PURE__ */ jsxs(ShareDialogContentContainer, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "solid",
        color: "primary",
        className: "platform",
        onClick: handleCopyLink,
        buttonName: ButtonName.ShareDialogButton,
        children: /* @__PURE__ */ jsx("span", { className: "platform-title", children: copyText })
      }
    ),
    /* @__PURE__ */ jsx(
      Snackbar,
      {
        open: snackbarOpen,
        autoHideDuration: 3e3,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        sx: (theme) => ({
          boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
          borderRadius: "7px",
          overflow: "hidden",
          position: desktopView ? "absolute" : "fixed",
          bottom: `${desktopView ? "1.5" : "1"}% !important`,
          backgroundColor: theme.vars.palette.background.default
        }),
        onClose: () => setSnackbarOpen(false),
        children: /* @__PURE__ */ jsx(
          Alert,
          {
            severity: "success",
            icon: /* @__PURE__ */ jsx(
              AppImage,
              {
                src: getImageAssetUrl("icon_success_tick.webp"),
                alt: "icon-success-tick",
                style: { maxWidth: "20px" }
              }
            ),
            sx: (theme) => ({
              backgroundColor: theme.vars.palette.background.default,
              boxShadow: "none",
              color: theme.vars.palette.text.primary,
              fontSize: 12,
              fontWeight: 600
            }),
            children: "Link copied"
          }
        )
      }
    )
  ] });
};
export {
  SharePage
};
//# sourceMappingURL=SharePage.js.map
